import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export const useLoginRegister = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();

  function handleLogin() {
    if (uuidAgendamento) {
      navigate(`/agendamento/${uuidAgendamento}/auth/login`);
      return;
    }
    navigate(`/agendamento/auth/login`);
  }

  function handleRegister() {
    if (uuidAgendamento) {
      navigate(`/agendamento/${uuidAgendamento}/auth/cadastro-usuario`);
      return;
    }
    navigate(`/agendamento/auth/cadastro-usuario`);
  }

  return { handleLogin, handleRegister };
};
